export default __webpack_public_path__ + "3b9afbd75bb253b26e467f282315cc06.svg";